import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-8 pb-8 text-center">
          <XCircle className="h-16 w-16 text-rose-500 mx-auto mb-4" />
          <h2 className="font-heading text-2xl font-bold text-slate-900 mb-2">
            Payment Cancelled
          </h2>
          <p className="text-slate-600 mb-6">
            Your payment was cancelled. You can try again anytime from your dashboard.
          </p>
          <Button
            onClick={() => navigate('/parent')}
            className="bg-slate-900 hover:bg-slate-800"
            data-testid="go-to-dashboard-btn"
          >
            Return to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
